import { css } from 'styled-components';
import { PopupProviderProps } from './models';

export const openPortalTag = 'portal-open';

export const PopupProvider = css<PopupProviderProps>(({ theme, activePopupBackdropCss }) => {
  return css`
    width: 100%;
    height: 100%;
    display: flex;

    &.${openPortalTag} {
      ${activePopupBackdropCss};
    }
  `;
});
